var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Ra trường – Nhân sự",
        visible: _vm.dialogVisible,
        width: "560px",
        "before-close": _vm.closeDialog,
        "close-on-click-modal": false,
        "custom-class": "sk-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "sk-dialog-content" }, [
        _c(
          "div",
          { staticClass: "sk-panel" },
          [
            _c("div", { staticClass: "sk-panel-head" }, [
              _c("div", { staticClass: "sk-panel-icon" }, [
                _c("i", { staticClass: "el-icon-s-promotion" }),
              ]),
              _c("div", [
                _c("p", { staticClass: "sk-panel-title" }, [
                  _vm._v("Chọn trạng thái ra trường"),
                ]),
                _c("p", { staticClass: "sk-panel-subtitle" }, [
                  _vm._v(
                    "Xác nhận trạng thái và ngày ra trường của các nhân viên đã chọn."
                  ),
                ]),
              ]),
            ]),
            _c(
              "el-form",
              { attrs: { "label-width": "130px" } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "Trạng thái" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { placeholder: "Chọn trạng thái" },
                        model: {
                          value: _vm.dataSearch.idGroupOut,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataSearch, "idGroupOut", $$v)
                          },
                          expression: "dataSearch.idGroupOut",
                        },
                      },
                      _vm._l(_vm.employeeStatusList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { value: item.id, label: item.name },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Ngày ra trường" } },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        type: "date",
                        clearable: false,
                        "value-format": "yyyy-MM-dd",
                        format: "dd-MM-yyyy",
                        placeholder: "Chọn ngày ra trường",
                      },
                      model: {
                        value: _vm.dataSearch.dateOut,
                        callback: function ($$v) {
                          _vm.$set(_vm.dataSearch, "dateOut", $$v)
                        },
                        expression: "dataSearch.dateOut",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "span",
        {
          staticClass: "sk-dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              staticClass: "btn-cancel",
              attrs: { type: "danger", size: "medium" },
              on: {
                click: function ($event) {
                  return _vm.closeDialog()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-close" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("button.close")))]),
            ]
          ),
          _c(
            "el-button",
            {
              staticClass: "btn-save",
              attrs: {
                type: "success",
                size: "medium",
                loading: _vm.loadingButton,
              },
              on: {
                click: function ($event) {
                  return _vm.submitForm()
                },
              },
            },
            [
              _c("i", { staticClass: "el-icon-circle-check" }),
              _c("span", [_vm._v(_vm._s(_vm.$t("button.save")))]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }